const testimonialsSliderInit = (block) => {
    const sliders = block ? [block[0].querySelector(".bn-testimonials-slider .swiper")] : Array.from(
        document.querySelectorAll(".bn-testimonials-slider .swiper")
    );

    const PARTIAL_CLASS = 'swiper-slide--partial';
    const DESKTOP_SHARP = 3;
    const markPartialSlide = (swiper) => {
        const swRect = swiper.el.getBoundingClientRect();
        const desktop = window.innerWidth >= 1200;
        const step = (swiper.slidesGrid[1] - swiper.slidesGrid[0]) || null;
        swiper.slides.forEach((s) => {
            const r = s.getBoundingClientRect();
            let faded;
            if (desktop && step) {
                const offset = Math.round((r.left - swRect.left) / step);
                faded = offset >= DESKTOP_SHARP;
            } else {
                faded = !(r.left >= swRect.left - 2 && r.right <= swRect.right + 2);
            }
            s.classList.toggle(PARTIAL_CLASS, faded);
        });
    };

    if (sliders) {
        sliders.forEach((slider) => {
            if (slider) {
                const sliderConfig = {
                    observer: true,
                    observeSlideChildren: true,
                    loop: true,
                    loopedSlides: 5,
                    autoplay: {
                        delay: 5000,
                    },
                    slidesPerView: 1.1,
                    spaceBetween: 10,
                    centeredSlides: true,
                    breakpoints: {
                        // > 450px: two centered slides; below: one. Center mode + 10px gap on mobile.
                        450: {
                            slidesPerView: 1.5,
                            spaceBetween: 10,
                            centeredSlides: true,
                        },
                        // tabletL and up: back to the standard left-aligned layout.
                        992: {
                            slidesPerView: "auto",
                            spaceBetween: 20,
                            centeredSlides: false,
                            loopedSlides: 5,
                        },
                       
                    },
                    allowTouchMove: slider.dataset.allowtouchmove === "0",
                    navigation: {
                        nextEl: slider.parentNode.querySelector(".swiper-button-next"),
                        prevEl: slider.parentNode.querySelector(".swiper-button-prev"),
                    },
                    on: {
                        init: markPartialSlide,
                        setTranslate: markPartialSlide,
                        transitionEnd: markPartialSlide,
                        slideChange: markPartialSlide,
                        breakpoint: markPartialSlide,
                    },
                }

                let currentSlider = new Swiper(slider, sliderConfig);
                currentSlider.on('observerUpdate', () => {
                    currentSlider.destroy(currentSlider, true);
                    currentSlider = new Swiper(slider, sliderConfig);
                });
            }
        });
    }
}

document.addEventListener("DOMContentLoaded", function () {
    if (document.body && !document.body.classList.contains('block-editor-page') && !document.body.classList.contains('block-editor-iframe__body'))
        testimonialsSliderInit();
    else if (window.acf)
        window.acf.addAction('render_block_preview/type=bn/testimonials-slider', testimonialsSliderInit);
});